import React from 'react';
import WHLastStep from './WHLastStep';

export default function WHLastStepConatiner({ formikProp, isLoading }) {
  return <WHLastStep formikProp={formikProp} isLoading={isLoading} />;
}
